import { mainFeature } from "../../data/jaanoFeatures";
import { motion } from "framer-motion";

const Section3 = () => {
  return (
    <section className="w-full px-4 md:px-12 py-10">
      <h3 className="text-center text-3xl sm:text-4xl font-bold leading-tight">
        Why{" "}
        <span className="bg-gradient-to-l from-lightprimary via-red-500 to-indigo-500 text-transparent bg-clip-text">
          Jaano.AI Chatbot
        </span>{" "}
        is the Smart Choice for You
      </h3>

      <p className="text-center text-base sm:text-lg text-gray-700 mt-4 mb-10 max-w-3xl mx-auto">
        Empower your business with AI-driven customer interactions and seamless
        automation.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {mainFeature.map(({ id, title, description, icon }) => (
          <motion.div
            key={id}
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
            className="p-6 bg-white rounded-2xl shadow-lg flex flex-col items-center text-center h-full hover:shadow-xl transition-shadow duration-300">
            <div className="mb-4 h-[120px] flex items-center justify-center">
              <img
                src={icon}
                alt={title}
                className="max-h-[200px] object-contain aspect-video"
              />
            </div>

            <h4 className="text-xl font-semibold text-darkprimary">{title}</h4>

            <p className="mt-2 text-gray-600">{description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Section3;
